import { ErrorMessage, Formik } from "formik";
import { useEffect, useState } from "react";
import { Col, Form, Input, Label, Row } from "reactstrap";

import {
  StaffSubmitHandler,
  addModalInitialValuesHandler,
} from "./AddAssetSubCategoryMethods/AddAssetSubCategoryModalMethods";
import {
  AddAssetCategoryInitialValues,
  AssetCategoryValidationSchema,
} from "./AddAssetSubCategoryMethods/FormikValidation";
import { AddSeatProps } from "../../../../../Type";
import CustomButton from "../../../../../Components/CustomElements/FormElements/CustomButton";
import TextError from "../../../../../Components/FormikError/TextError";

const AddAssetSubCategory = ({
  setIsOpen,
  modalEditData,
  refetch,
  id
}: AddSeatProps) => {
  const [addModalInitialValues, setAddModalInitialValues] = useState(
    AddAssetCategoryInitialValues
  );
  const [editMode, setEditMode] = useState<boolean>(false);

  useEffect(() => {
    addModalInitialValuesHandler(
      modalEditData,
      setAddModalInitialValues,
      setEditMode
    );
  }, [modalEditData]);

  return (
    <Formik
      validationSchema={AssetCategoryValidationSchema}
      initialValues={addModalInitialValues}
      enableReinitialize
      onSubmit={(values, actions) => {
        StaffSubmitHandler(
          values,
          actions,
          setIsOpen,
          refetch,
          editMode,
          modalEditData?.[0]?.id,
          id
        );
      }}
    >
      {({
        handleSubmit,
        handleChange,
        isSubmitting,
        values,
        setFieldValue,
        setFieldError,
        errors,
      }) => {
        return (
          <div className="form-wrap asset-form-wrap">
            <Form onSubmit={handleSubmit}>
              <Row className="gy-4">
                <Col lg={12}>
                  <Label>Asset Sub Category name</Label>
                  <Input
                    type="text"
                    onChange={handleChange}
                    value={values?.name}
                    name="name"
                    placeholder="Asset Sub Category Name"
                  />
                  <ErrorMessage name="name" component={TextError} />
                </Col>
                <Col lg={12}>
                  <div className="checkbox-wrap"> 
                    <input
                      name="document"
                      type="checkbox"
                      className="form-check-input"
                      onChange={handleChange}
                      checked={values.document}
                    />
                    <Label>Asset Sub Category name</Label>
                    <ErrorMessage name="document" component={TextError} />
                  </div>
                </Col>

                <Col lg={12}>
                  <CustomButton
                    isLoading={isSubmitting}
                    label="Submit"
                    color="primary"
                    className="sm submit-btn"
                  />
                </Col>
              </Row>
            </Form>
          </div>
        );
      }}
    </Formik>
  );
};

export default AddAssetSubCategory;
